module.exports = __webpack_public_path__ + "static/media/etat-sante-grey.1091a6ae.svg";